"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon as ChakraIcon, forwardRef } from "@chakra-ui/react";
const Icon = forwardRef((props, ref) => (_jsx(ChakraIcon, Object.assign({ ref: ref }, props, { boxSize: "initial" }))));
export default Icon;
//# sourceMappingURL=Icon.js.map